import { NewLossReportWrapper } from "../../components/CustomerForm/NewLossReportWrapper";

export function NewLossReport() {
	return (
		<>
			<NewLossReportWrapper />
		</>
	);
}
